import '../sass/pages/_loader.scss';

const Loading = () => {

    return (
        <div className='loading'>
        </div>
    );
};

export default Loading;